export type IdLike = string | number;

/**
 * Normalizes an ID to be used safely as an object key.
 * Converts numbers to strings and handles any potential edge cases
 * (like trimming whitespace if it's already a string).
 * @param id The identifier to normalize
 * @returns A strictly formatted string representation of the ID
 */
export function normalizeIdKey(id: IdLike): string {
  if (id === null || id === undefined) {
    return '';
  }

  return String(id).trim();
}
